// extracted by mini-css-extract-plugin
module.exports = {"houseSelector":"styles_houseSelector__36aSI"};